export default "__VITE_ASSET__CHpXhl20__"